(function(){
  var f = document.getElementById('offerForm'); if(!f) return;
  function u(){
    var i = f.querySelector('input[name="pack"]:checked'); if(!i) return;
    document.getElementById('ctaLabel').textContent = i.dataset.label + ' · ' + i.dataset.price + ' zł';
    document.getElementById('stickyPrice').textContent = i.dataset.price + ' zł';
    document.getElementById('stickyLabel').textContent = i.dataset.label;
    ['ctaMain','ctaSticky'].forEach(function(k){ document.getElementById(k).href = '/cart/' + i.value + ':1'; });
  }
  f.addEventListener('change', u); u();
  var m = document.getElementById('flkMain');
  document.querySelectorAll('.flk .thumb').forEach(function(b){
    b.addEventListener('click', function(){ if(m){ m.src = b.dataset.src; } });
  });
  var c = document.getElementById('cutoff');
  if(c){ c.textContent = new Date().getHours() < 14 ? 'dziś do 14:00' : 'jutro do 14:00'; }
})();